import React, { Component } from 'react'
import './Grid.css';

//Global Variables
var gridSize = 30;

var startNode = "";
var startX = 1;
var startY = 1;

var endNode = "";
var endX = gridSize-2;
var endY = gridSize-2;

var openList = [];
var closedList = [];

//Main color themes
var weightedColor = "magenta";
var viableColor = "cornflowerblue";
var neighborColor = "lightskyblue";

//Javascript code to generate grid of divs
function genGrid(n){
    document.body.style.backgroundColor = "lightgray";
    document.body.style.textAlign = "center";
    document.body.style.fontFamily = "Courier, monospace";

    var e = document.createElement("div");
    e.style.textAlign = "center";
    for(var i = 0; i < n; i++){
        var row = document.createElement("div");
        row.style.display = "inline-block";
        for(var j = 0; j < n; j++){ 
            var cell = document.createElement("div");
            cell.id = "cell" + oneToTwo(i) + oneToTwo(j);
            cell.style.width = " 2.4vh";
            cell.style.height = "2.4vh";
            cell.style.border = "solid .18vh purple";
            cell.style.backgroundColor = "white";
            row.appendChild(cell);
        } 
        e.appendChild(row);
    }
    document.body.appendChild(e);//Grid

    var link = document.createElement('a');
    var linkText = document.createTextNode("Visit My Portfolio");
    link.setAttribute("href", "https://coles-website1.web.app");
    link.appendChild(linkText);
    document.body.appendChild(link);
}

/* New Toy */
window.onclick = e => {
    if(e.target.id.charAt(0) === "c"){
        if(e.target.style.backgroundColor === "black"){
            e.target.style.backgroundColor = "white";
        }
        else{
            e.target.style.backgroundColor = "black";
        }
    }
}


//Function to erase all colored nodes in grid
function clearGrid(){
    var n = gridSize;
    for(var i = 0; i < n; i++){
        for(var j = 0; j < n; j++){
            var cell = document.getElementById("cell" + oneToTwo(i) + oneToTwo(j));
            if(cell.style.border !== "solid .18vh purple") cell.style.border = "solid .18vh purple";
            if(cell.style.backgroundColor !== "white") cell.style.backgroundColor = "white";
        }   
    }
}

//Function to clear the path and neighbors. Not walls or start/end nodes
function clearPath(){
    var n = gridSize;
    for(var i = 0; i < n; i++){
        for(var j = 0; j < n; j++){
            var cell = document.getElementById("cell" + oneToTwo(i) + oneToTwo(j));
            if(cell.style.border !== "solid .18vh purple") cell.style.border = "solid .18vh purple";
            if(cell.style.backgroundColor !== "green" && cell.style.backgroundColor !== "red" && cell.style.backgroundColor !== "black" && cell.style.backgroundColor !== "magenta"){
                 cell.style.backgroundColor = "white";
            }
        }   
    }
}

//Function to clear the walls
function clearWalls(){
    var n = gridSize;
    for(var i = 0; i < n; i++){
        for(var j = 0; j < n; j++){
            var cell = document.getElementById("cell" + oneToTwo(i) + oneToTwo(j));
            if(cell.style.backgroundColor === "black"){
                 cell.style.backgroundColor = "white";
            }
        }   
    }
}


//Method to let user set start and end nodes
function setStartEnd(){
    clearTargets();
    var form = document.getElementsByClassName('form');
    var strArr = [];

    //Form values are returned as strings
    for(var i = 0; i < form.length; i++){
        strArr[i] = isValidNum(form[i].value);
    }

    //in case of no inputs
    startX = (strArr[0].length > 0 ) ? parseInt(strArr[0]) : 1; 
    startY = (strArr[1].length > 0 ) ? parseInt(strArr[1]) : 1;  
    endX = (strArr[2].length > 0 ) ? parseInt(strArr[2]) : gridSize - 2;
    endY = (strArr[3].length > 0 ) ? parseInt(strArr[3]) : gridSize - 2;  

    startNode = "cell" + oneToTwo(startX) + oneToTwo(startY); 
    endNode = "cell" + oneToTwo(endX) + oneToTwo(endY);

    var cell1 = document.getElementById(startNode);
    var cell2 = document.getElementById(endNode);
    
    cell1.style.backgroundColor = "green";
    cell2.style.backgroundColor = "red";
}

//Function to clear start and stop nodes in grid
function clearTargets(){
    var n = gridSize;
    for(var i = 0; i < n; i++){
        for(var j = 0; j < n; j++){
        var cell = document.getElementById("cell" + oneToTwo(i) + oneToTwo(j));
            if(cell.style.backgroundColor === "red" || cell.style.backgroundColor === "green"){
                cell.style.backgroundColor = "white";
            }
        }   
    }
}

//Print start and end nodes
function printNodes(){
    var text = document.createElement('p');
    text.innerHTML = "Start Node: (" + startX + "," + startY + ") End Node: (" + endX + "," + endY + ")";
    text.id = "text";
    document.body.appendChild(text);
    var butt = document.createElement('button');
    butt.className = "newButton";
    butt.innerHTML = "Delete";
    butt.onclick = clearButton;
    document.body.appendChild(butt);
}

//Clear the text and button after the start and end nodes get set
function clearButton(){
    var ele = document.getElementById('text');
    ele.parentNode.removeChild(ele);
    var ele2 = document.getElementsByClassName('newButton');
    ele2[0].parentNode.removeChild(ele2[0]);
}

//Method to set random walls
function setWalls(){
    for(var i = 0; i < gridSize/4; i++){
        var randomNum1 = Math.floor(Math.random()*gridSize);
        var randomNum2 = Math.floor(Math.random()*gridSize);
        var tot = "" + oneToTwo(randomNum1) + "" + oneToTwo(randomNum2);
        var cell = document.getElementById('cell' + tot);
        if(cell.style.backgroundColor === "white"){
            cell.style.backgroundColor = "black";
        }
    }
}

//Set random weighted nodes
function setWeightedNodes(){
    for(var i = 0; i < gridSize/4; i++){
        var randomNum1 = Math.floor(Math.random()*gridSize);
        var randomNum2 = Math.floor(Math.random()*gridSize);
        var tot = "" + oneToTwo(randomNum1) + "" + oneToTwo(randomNum2);
        var cell = document.getElementById('cell' + tot);
        if(cell.style.backgroundColor === "white"){
            cell.style.backgroundColor = weightedColor;
        }
    }
}

function Node(x,y){
    this.x = x;            
    this.y = y;
    this.h1 = 0;
    this.h2 = 0;
    this.f = 0;
    this.parent = null;
    this.name = "cell" + oneToTwo(x) + oneToTwo(y);
}

/*  -   -   -   -   -   -   - A* Search   -   -   -   -   -   -   -   -   -   */

function AstarSearch(){
    clearPath();
    //Create start and end nodes
    var node = new Node(startX, startY);
    var targetNode = new Node(endX, endY); 
    openList.push(node);
    var solution = false;

    while(openList.length > 0){

        //find node with least f in open list and call it "q" 
        var index = leastIndexList();
        var q = Object.assign({}, openList[index]);

        //remove q from openList
        openList.splice(index,1);

        var thought = document.getElementById(q.name);
        thought.style.backgroundColor = viableColor;

        //Reached End Goal
        if(q.name === targetNode.name){
            solution = true;
            pathFound(q);
            break;
        }

        closedList.push(q);

        var successorList = [];
        if(q.x > 0) successorList.push(new Node(q.x - 1, q.y));
        if(q.x < gridSize -1) successorList.push(new Node(q.x + 1, q.y));
        if(q.y > 0) successorList.push(new Node(q.x, q.y - 1));
        if(q.y < gridSize -1) successorList.push(new Node(q.x, q.y + 1));

        //To do Loop for each successor
        for(var i = 0; i < successorList.length; i++){
            if(isValid(successorList[i]) === false) continue;
            if(findNode(successorList[i], closedList) === true) continue;

            var h1Score = q.h1 + getHeuristic1(successorList[i]);
            var h1Best = false;

            if(findNode(successorList[i], openList) === false){
                h1Best = true;
                successorList[i].h2 = getHeuristic2(successorList[i]);
                openList.push(successorList[i]);
            }
            else if(h1Score < successorList[i].h1) h1Best = true;

            if(h1Best){
                var cell = document.getElementById(successorList[i].name);
                if(cell.style.backgroundColor === weightedColor) cell.style.border = "solid .18vh magenta";
                cell.style.backgroundColor = neighborColor;
                
                successorList[i].parent = q;
                successorList[i].h1 = h1Score;
                successorList[i].f = successorList[i].h1 + successorList[i].h2;
            }    
        }//End For Loop
    }//End While Loop
    openList = [];
    closedList = [];
    if(solution === false) noPath();
}//End A* search

//Heuristic 1 - Move Cost | Magenta = 3 | white = 1 
function getHeuristic1(givenNode){
    if(document.getElementById(givenNode.name).style.backgroundColor === weightedColor){
        return 5;
    }
    else if(document.getElementById(givenNode.name).style.backgroundColor === "black"){
        return 1000;
    }
    return 1;
}

//Heuristic 2 - Get Manhattan Distance
function getHeuristic2(givenNode){
    return Math.abs(givenNode.x - endX) + Math.abs(givenNode.y - endY);
}

//Checks to see if the given node is a wall
function isValid(givenNode){
    var cell = document.getElementById(givenNode.name);
    if(cell.style.backgroundColor === "black") return false;
    return true;
}

//Returns index of Node with least f heuristic
function leastIndexList(){
    var least = 1000;
    var i = 0;
    var save = 0;
    for(i = 0; i < openList.length;i++){
        if(openList[i].f < least){
             least = openList[i].f;
             save = i;
        }
    }
    return save;
}

//function to find a given node in the specified list
function findNode(givenNode, list){
    for(var i = 0; i < list.length; i++){
        if(givenNode.name === list[i].name) return true;
    }
    return false;
}

//Function to call once target node is reached - Prints ideal path
function pathFound(found){
    var cell = document.getElementById(found.name);
    cell.style.backgroundColor = "red";
    found = found.parent;
    while(found.parent !== null){
        cell = document.getElementById(found.name);
        cell.style.backgroundColor = "#80ff80";
        found = found.parent;
    }
    cell = document.getElementById(found.name);
    cell.style.backgroundColor = "green";
}

//turns 3 into "03" | turns 1 into "01"
function oneToTwo(num){
    if(num < 10) return "0" + num;
    return num;
}

//Function to take care of NaN numbers inputted into html form
function isValidNum(strNum){
    //if string is not a number return a random string number within the grid
    if(isNaN(strNum) === true) return "" + Math.random()*gridSize;
    //else check if the number is within the gridSize 
    if(parseInt(strNum) < 0) return "" + 0;
    else if(parseInt(strNum) >= gridSize) return "" + gridSize - 1;
    //if string is valid number within range, then just return it
    return strNum;
}

var explan = "A* search is one the most popular search algorithms in artificial intelligence. " +
             "It is most often used in GPS or destination determined solutions to find the shortest " +
             "possible path from point A to point B. In this demonstration you can manipulate " +
             "the path by adding walls and weighted nodes. Weighted nodes have a higher cost of traveling " +
             "across than regular nodes. They can essentially act as traffic in a given area. Enjoy!";

//Show Explanation button
function explanButton(){
    var cell = document.createElement('button');
    cell.id = "explanButton";
    cell.innerHTML = "Show Demo Explanation";
    cell.onclick = def;
    document.body.appendChild(cell);
}

//Demo definition
function def(){
    var outer = document.createElement('div');
    outer.id = "expDiv";
    var descriptDiv = document.createElement('div');
    descriptDiv.style.padding = "3vh";
    descriptDiv.innerHTML = explan;
    descriptDiv.id = "def";
    descriptDiv.style.border = "solid .2vh black";
    descriptDiv.style.textAlign = "left";
    descriptDiv.style.width = "70vh";
    descriptDiv.style.margin = "auto";
    descriptDiv.style.backgroundColor = "slategrey";

    var list = document.createElement('ul');
    var item1 = document.createElement('li');
    var item2 = document.createElement('li');
    var item3 = document.createElement('li');
    item1.innerHTML = "The index of the top left corner is (0,0)";
    item2.innerHTML = "The index of the bottom right corner is (29,29)";
    item3.innerHTML = "Click the nodes to add or remove walls";
    list.appendChild(item1);
    list.appendChild(item2);
    list.appendChild(item3);

    //Delete explan Button 
    var cell = document.getElementById('explanButton');
    cell.parentNode.removeChild(cell);

    //create new hide button
    var hideButt= document.createElement('button');
    hideButt.id = "hideButt";
    hideButt.innerHTML = "Hide Explanation";
    hideButt.onclick = hide;//on click run hide function
    document.body.appendChild(hideButt);

    descriptDiv.appendChild(list);
    outer.appendChild(descriptDiv);
    document.body.appendChild(outer);
}

//Hide button - Delete hide button and explan div add explan button 
function hide(){
    var hideButton = document.getElementById("hideButt");
    hideButton.parentNode.removeChild(hideButton);

    var expDiv = document.getElementById("expDiv");
    expDiv.parentNode.removeChild(expDiv);
    explanButton();
}

//Function called if no path is found 
function noPath(){
    var div = document.createElement('div');
    div.id = "msg";
    div.style.position = "absolute";
    div.style.top = "50px";
    div.style.width = "200px";
   
    div.innerHTML = "No possible path. Try again!"
    div.style.color = "white";
    div.style.backgroundColor = "slategray";
    div.style.border = "solid .18vh black";
    div.style.borderRadius = ".5vh";

    var butt = document.createElement('button');
    butt.innerHTML = "Hide";
    div.appendChild(butt);
    butt.onclick = deleteMsg;
    document.body.appendChild(div);
}

//Delete no path message
function deleteMsg(){
    var cell = document.getElementById("msg");
    cell.parentNode.removeChild(cell);
    clearGrid();
    setStartEnd();
}

/* -   -   -   -   -   -   -  HTML   -   -   -   -   -   -   -   -   -    */
class Grid extends Component {
    render() {
        return (
            <div className="bg">
                {genGrid(gridSize)}
                {explanButton()}
                <div>
                    <div className="buttonWrapper">

                        <button 
                                    className= "button" 
                                    onClick={setWalls}> 
                                    Set Random Walls
                        </button>

                        <button 
                                    className= "button" 
                                    onClick={setWeightedNodes}> 
                                    Set Weighted Nodes
                        </button>

                        <button 
                                    className= "button" 
                                    onClick={clearGrid}> 
                                    Clear Grid
                        </button>

                        <button 
                                    className= "button" 
                                    onClick={clearWalls}> 
                                    Clear Walls
                        </button>

                        <button 
                                    className= "button" 
                                    onClick={clearPath}> 
                                    Clear Path
                        </button>

                        <button 
                                    className= "button" 
                                    onClick={printNodes}> 
                                    Print Target Nodes
                        </button>

                        <button 
                                    className= "button" 
                                    onClick={AstarSearch}> 
                                    Run A* Search
                        </button>

                    </div>


                    <div className="startEndNodes">
                        <form>
                            <label style={{fontSize:"12px"}}>
                                x1:
                                <input className = "form" type="text" name="start"/>
                                y1:
                                <input className = "form" type="text" name="end"/>
                                x2:
                                <input className = "form" type="text" name="start"/>
                                y2:
                                <input className = "form" type="text" name="end"/>
                            </label>
                        </form>
                        <button className="button" onClick = {setStartEnd}>Set Start And End Nodes</button>
                    </div>

                </div>
            </div>
        )
    }
}

export default Grid;